export const api = {
    auth: {
        login: '/auth/v1/login',
        refreshToken: '/auth/v1/refresh-token',
    },
    locksmith: {
        list: '/locksmith/v1/list',
        delete: '/locksmith/v1/delete/',
        create: '/locksmith/v1/create',
        edit: '/locksmith/v1/edit/',
        detail: '/locksmith/v1/detail/',
        stats: '/locksmith/v1/stats',
        nearest: '/locksmith/v1/list-nearest',
        clock: '/locksmith/v1/clock',
        job: '/locksmith/v1/job',
        complain: '/locksmith/v1/complain',
        distanceNTime: '/locksmith/v1/get-distance-duration',
    }
}